import { Theme } from '.';

export * from '@wre/infinity-generators/theme/colors';

export function getColorFromTheme(color: string, theme: Theme): string {
  return (theme.colors as Record<string, string>)[color] ?? color;
}
